module.exports = __webpack_public_path__ + "img/halloween_bat.8a58c9ef.svg";